import React from 'react'
import { Navbar } from './components/UI/NavBar';
import HomePage from './pages/HomePage';
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Buscar from './components/Forms/Buscar';

const BuzonEticoApp = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/buscar-consulta" element={<Buscar />} />
      </Routes>
    </>
  )
}

export default BuzonEticoApp;
